<template>
  <div class="activitie" v-html="html">
  </div>
</template>
<script>
import { getActivitiesInfo } from 'api/activities'
export default {
  name: 'hotactivity',
  data () {
    return {
      html: ''
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      const id = this.$route.query.id
      getActivitiesInfo({ activityId: id }).then((res) => {
        document.title = res.data.data.name
        this.html = res.data.data.content ? res.data.data.content : ''
      })
    }
  }
}
</script>
<style>
.activitie p{
  margin: 0px;
  padding: 0px;
  font-size: 14px;
}
.activitie img{
  display: block !important;
  width: 100% !important;
  height: auto !important;
}
span{
  font-weight: normal;
}
strong{
  font-weight: bold;
}
.ql-size-small{
  font-size: 12px;
}
.ql-size-large{
  font-size: 18px;
}
.ql-size-huge{
  font-size: 24px;
}
</style>
